import { Menu, Text, UnstyledButton } from "@marketplace/ui";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { type AuthUser, useLogout } from "@/modules/auth";

const ExitToAppIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="currentColor"
        d="M6.992 11.575a.83.83 0 001.175 0l2.991-2.992a.83.83 0 000-1.175L8.167 4.417a.83.83 0 10-1.175 1.175l1.566 1.575H1.333A.836.836 0 00.5 8c0 .458.375.833.833.833h7.225L6.992 10.4a.838.838 0 000 1.175zM13.833.5H2.167C1.242.5.5 1.25.5 2.167v2.5c0 .458.375.833.833.833a.836.836 0 00.834-.833V3c0-.458.375-.833.833-.833h10c.458 0 .833.375.833.833v10a.836.836 0 01-.833.833H3A.836.836 0 012.167 13v-1.667a.836.836 0 00-.834-.833.836.836 0 00-.833.833v2.5c0 .917.75 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667V2.167C15.5 1.25 14.75.5 13.833.5z"
      ></path>
    </svg>
  );
};

type UserInfoProps = {
  userData: AuthUser | null;
};

export const UserInfo = ({ userData }: UserInfoProps) => {
  const { t } = useTranslation("common");
  const logout = useLogout();
  const navigate = useNavigate();

  const handleClickToProfile = () => {
    navigate({
      to: "/settings/profile"
    });
  };

  const handleLogout = async () => {
    await logout();
  };

  return (
    <Menu width={222}>
      <Menu.Target>
        <UnstyledButton
          id="profile"
          className="text-[#fefefe] flex gap-x-3 items-center"
        >
          <div className="text-right">
            <Text className="mb-[2px]">
              {userData?.name ?? "Unknown person"}
            </Text>
            <Text size="s">{userData?.email ?? "Unknown email"}</Text>
          </div>
          <div className="w-[46px] h-[46px] rounded-full overflow-hidden bg-gray-300">
            <img
              src="/images/user-placeholder.webp"
              alt="User placeholder"
              width={46}
              height={46}
            />
            {/* <img src={picture!} alt="User picture" width={46} height={46} /> */}
          </div>
        </UnstyledButton>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item onClick={handleClickToProfile}>{t("myProfile")}</Menu.Item>
        <Menu.Item onClick={handleLogout} leftSection={<ExitToAppIcon />}>
          {t("logout")}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
